import axios from "axios";
// import { useAuthStore } from "@/store/authStore";

// 导出基础URL，供其他模块使用
// export const baseURL = "https://192.168.110.221:8848";
// export const baseURL = "https://www.libingjiaoyu.com:8848";
export const baseURL = "https://www.libingjiaoyu.com:8848";
// 创建axios实例并配置基础URL
const apiClient = axios.create({
  // baseURL: "http://192.168.110.47:8848/", // 基础地址
  baseURL: baseURL, // 基础地址
  // baseURL: "https://www.libingjiaoyu.com:8848", // 基础地址
  timeout: 120000, // 请求超时时间
});
// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 不需要认证的接口列表
    const noAuthPaths = [
      '/interface/login',
      '/interface/sms/login',
      '/interface/userregister',
      '/interface/sms/sendCode',
      '/interface/wrjquestionbank/list',
      '/interface/wrjquestionbank/random',
      '/interface/wrjquestionbank/exam/start',
      '/captchaImage',
      '/interface/examination/medical',
      '/interface/examination/political',
      '/interface/examination/career',
      '/interface/examination/female',
      '/interface/rank/query',
      '/interface/interview/random',
      '/interface/interview/answers',
      '/interface/interview/evaluate',
      // '/interface/interview/save',
      '/interface/process/all',
      '/interface/process/processlist',
      '/interface/information/list',
      '/interface/information/',
      '/interface/expert/list',
      '/interface/expert/detail/',
      '/interface/expert/question/list',
      '/interface/expert/question/detail/',
      '/interface/expert/question/add',
      '/interface/survey/questions',
      '/interface/pageview/report',
      '/interface/pageview/getpageview',
      '/interface/pageview/savepageview'
    ];

    // 检查当前请求是否需要认证
    // 处理完整URL或相对路径的情况
    let url = config.url;
    console.log('原始请求URL:', url);

    // 如果是完整URL，提取路径部分
    if (url.startsWith('http')) {
      try {
        const urlObj = new URL(url);
        url = urlObj.pathname;
      } catch (e) {
        console.error('解析URL失败:', e);
      }
    }

    console.log('处理后的路径:', url);

    // 检查是否是survey相关接口（仅/questions不需要认证）
    const isSurveyPath = url.includes('/interface/survey/questions');
    const isNoAuthPath = noAuthPaths.some(path => url.includes(path));

    console.log('是否survey接口:', isSurveyPath);
    console.log('是否无需认证:', isNoAuthPath);

    // 对于不需要认证的接口，确保删除任何可能存在的token头
    if (isNoAuthPath || isSurveyPath) {
      delete config.headers['token'];
      console.log('已删除token头');
    } else {
      // 直接从 localStorage 获取 token
      const authData = localStorage.getItem("auth");
      if (authData) {
        try {
          const storedAuth = JSON.parse(authData);
          // 处理Pinia的存储结构，token可能在state中或直接存储
          const authState = storedAuth.state || storedAuth;
          const token = authState._token;
          if (token) {
            // 后端期望的是 token 请求头，而不是 Authorization
            config.headers["token"] = `${token}`;
          }
        } catch (e) {
          console.error("解析 auth 状态失败", e);
        }
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截器：处理 401 自动登出
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // 检测是否是 401 未授权错误
//     if (error.response?.status === 401) {
//       const authStore = useAuthStore();
//       authStore.logout(); // 清除登录状态

//       // 可选：跳转到登录页（需要 router 实例）
//       // import { useRouter } from 'vue-router';
//       // const router = useRouter();
//       // router.push('/login');
//     }

//     // 继续抛出错误以便后续处理
//     return Promise.reject(error);
//   }
// );

export default apiClient;
